module.exports = __webpack_public_path__ + "img/logo.a908a471.png";